exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notifications .list-move{transition:transform .3s,opacity .4s}.notifications .list-item{display:inline-block;margin-right:10px}.notifications .list-enter-active{transition:transform .2s ease-in,opacity .4s ease-in}.notifications .list-leave-active{transition:transform 1s ease-out,opacity .4s ease-out}.notifications .list-enter{opacity:0;transform:scale(1.1)}.notifications .list-leave-to{opacity:0;transform:scale(1.2,.7)}", ""]);

// exports
